import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Blacklist } from '../model/blacklist.class';
import { setRootDomAdapter } from '@angular/platform-browser/src/dom/dom_adapter';

@Component({
    selector: 'app-blacklist',
    templateUrl: './blacklist.component.html'
})
export class BlacklistComponent {

    public midList = [];
    public blacklistDisplay = '';

    public addSingleMidInput = '';
    public addMidRangeStartInput = '';
    public addMidRangeEndInput = '';

    public removeSingleMidInput = '';
    public removeMidRangeStartInput = '';
    public removeMidRangeEndInput = '';

    public blacklist = null;

    message = '';

    constructor(public userService: UserService) {
        this.userService.getBlacklistByName('blacklist', 'blacklist').subscribe(
            (data) => {
                this.blacklist = data as Blacklist;
                this.blacklist.blacklistMids = this.sortMids(this.blacklist.blacklistMids);
                this.midList = this.blacklist.blacklistMids;
                for (let i = 0; i < this.blacklist.blacklistMids.length; i++) {
                    if (i === this.blacklist.blacklistMids.length - 1) {
                        this.blacklistDisplay = this.blacklistDisplay + this.blacklist.blacklistMids[i];
                    } else {
                        this.blacklistDisplay = this.blacklistDisplay + this.blacklist.blacklistMids[i] + ', ';
                    }
                }
            },
            (err) => console.log('Blacklist nicht vorhanden'));
    }

    addSingleMidToBlacklist() {
        if (this.validateInput(this.addSingleMidInput)) {
            let midsToAdd = this.convertMidInputToList(this.addSingleMidInput);
            for (let i = 0; i < midsToAdd.length; i++) {
                if (!this.midList.includes(midsToAdd[i])) {
                    this.midList.push(midsToAdd[i]);
                }
            }
            this.clearAllInputs();
            this.message = '';
            this.addMidsToBlacklist(this.midList);
        } else {
            this.message = 'Ungültige Eingabe!';
        }
    }

    addMidRangeToBlacklist() {
        if (this.validateInput(this.addMidRangeStartInput) && this.validateInput(this.addMidRangeEndInput)) {
            let startValue = parseInt(this.addMidRangeStartInput);
            let endValue = parseInt(this.addMidRangeEndInput);
            if (startValue < endValue) {
                let range = startValue + '-' + endValue;
                let midsToAdd = this.convertMidInputToList(range);
                for (let i = 0; i < midsToAdd.length; i++) {
                    if (!this.midList.includes(midsToAdd[i])) {
                        this.midList.push(midsToAdd[i]);
                    }
                }
                this.clearAllInputs();
                this.message = '';
                this.addMidsToBlacklist(this.midList);
            } else {
                this.message = 'Startwert muss kleiner als Endwert sein!';
            }
        } else {
            this.message = 'Ungültige Eingabe!';
        }
    }

    addMidsToBlacklist(mids: number[]) {
        if (this.blacklist) {
            this.blacklist.blacklistMids = mids;
            this.userService.update(this.blacklist, 'blacklist').subscribe(data => this.handleUpdateBlacklist(data));
        } else {
            this.blacklist = new Blacklist('blacklist', mids);
            this.userService.create(this.blacklist, 'blacklist').subscribe(data => this.handleCreateBlacklist(data));
        }
    }

    removeSingleMidFromBlacklist() {
        if (this.validateInput(this.removeSingleMidInput)) {
            let midsToRemove = this.convertMidInputToList(this.removeSingleMidInput);
            for (let i = 0; i < midsToRemove.length; i++) {
                if (this.midList.includes(midsToRemove[i])) {
                    this.midList.splice(this.midList.indexOf(midsToRemove[i]), 1);
                }
            }
            this.clearAllInputs();
            this.message = '';
            this.removeMidsFromBlacklist(this.midList);
        } else {
            this.message = 'Ungültige Eingabe!';
        }
    }

    removeMidRangeFromBlacklist() {
        if (this.validateInput(this.removeMidRangeStartInput) && this.validateInput(this.removeMidRangeEndInput)) {
            let startValue = parseInt(this.removeMidRangeStartInput);
            let endValue = parseInt(this.removeMidRangeEndInput);
            if (startValue < endValue) {
                let range = startValue + '-' + endValue;
                let midsToRemove = this.convertMidInputToList(range);
                for (let i = 0; i < midsToRemove.length; i++) {
                    if (this.midList.includes(midsToRemove[i])) {
                        this.midList.splice(this.midList.indexOf(midsToRemove[i]), 1);
                    }
                }
                this.clearAllInputs();
                this.message = '';
                this.removeMidsFromBlacklist(this.midList);
            } else {
                this.message = 'Startwert muss kleiner als Endwert sein!';
            }
        } else {
            this.message = 'Ungültige Eingabe!';
        }
    }

    removeMidsFromBlacklist(mids: number[]) {
        if (this.blacklist) {
            this.blacklist.blacklistMids = mids;
            this.userService.update(this.blacklist, 'blacklist').subscribe(data => {
                this.handleUpdateBlacklist(data);
            });
        }
    }

    handleUpdateBlacklist(data) {
        this.blacklist = data as Blacklist;
        this.blacklist.blacklistMids = this.sortMids(this.blacklist.blacklistMids);
        this.updateBlacklistForDisplay();
        console.log(this.blacklist);
    }

    handleCreateBlacklist(data) {
        this.blacklist = data as Blacklist;
        this.updateBlacklistForDisplay();
        console.log(this.blacklist);
    }

    updateBlacklistForDisplay() {
        if (this.blacklist) {
            this.userService.getBlacklistByName('blacklist', 'blacklist').subscribe(
                (data) => {
                    this.blacklist = data as Blacklist;
                    this.blacklist.blacklistMids = this.sortMids(this.blacklist.blacklistMids);
                    this.blacklistDisplay = '';
                    for (let i = 0; i < this.blacklist.blacklistMids.length; i++) {
                        if (i === this.blacklist.blacklistMids.length - 1) {
                            this.blacklistDisplay = this.blacklistDisplay + this.blacklist.blacklistMids[i];
                        } else {
                            this.blacklistDisplay = this.blacklistDisplay + this.blacklist.blacklistMids[i] + ', ';
                        }
                    }
                    if (this.blacklistDisplay === '') {
                        this.blacklistDisplay = 'Keine Elemente in der Blacklist enthalten';
                    }
                },
                (err) => console.log('Keine Blacklist vorhanden'));
        } else {
            this.blacklistDisplay = 'Keine Blacklist vorhanden';
        }
    }


    sortMids(mids: number[]) {
        mids.sort(function (a, b) { return a - b });
        return mids;
    }

    convertMidInputToList(input: string) {
        let list = [];
        if (input.includes("-")) {
            let range = input.split("-");
            for (let i = parseInt(range[0]); i <= parseInt(range[1]); i++) {
                list.push(i);
            }
        } else {
            list.push(parseInt(input));
        }
        return list;
    }

    validateInput(input) {
        let isValid = true;
        if (!input || input === "" || input.indexOf('-') !== -1 || input.indexOf('.') !== -1 || isNaN(input)) {
            isValid = false;
        }
        return isValid;
    }

    clearAllInputs(){
        this.addSingleMidInput = '';
        this.addMidRangeStartInput = '';
        this.addMidRangeEndInput = '';
        this.removeSingleMidInput = '';
        this.removeMidRangeStartInput = '';
        this.removeMidRangeEndInput = '';
    }

}



// WEBPACK FOOTER //
// ./src/app/blacklist/blacklist.component.ts